package com.karyadina.util

import androidx.compose.runtime.*
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.toComposeImageBitmap
import org.jetbrains.skia.Image
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array
import kotlinx.coroutines.await
import kotlinx.browser.window
import org.w3c.fetch.Response

@Composable
actual fun rememberImageBitmapFromUri(uri: String): ImageBitmap? {
    var bitmap by remember(uri) { mutableStateOf<ImageBitmap?>(null) }

    LaunchedEffect(uri) {
        try {
            // For blob URIs, we can try to fetch and decode
            if (uri.isNotEmpty()) {
                val response = window.fetch(uri).await()
                if (!response.ok) {
                    console.error("Failed to fetch image: ${response.status} ${response.statusText}")
                    throw Exception("Fetch failed")
                }
                val arrayBuffer = response.arrayBuffer().await()
                console.log("Image loaded from $uri, size: ${arrayBuffer.byteLength} bytes")
                
                // Use specific view to ensure we read correct bytes
                val byteArray = Int8Array(arrayBuffer, 0, arrayBuffer.byteLength).unsafeCast<ByteArray>()
                val skiaImage = Image.makeFromEncoded(byteArray)
                bitmap = skiaImage.toComposeImageBitmap()
            }
        } catch (e: Throwable) {
            console.error("Failed to load image from URI: $uri", e)
            bitmap = null
        }
    }
    return bitmap
}
